module.exports = __webpack_public_path__ + "img/uk.9ade6244.svg";